import { render, staticRenderFns } from "./PreviewEmailWrapper.vue?vue&type=template&id=25fca5dc"
import script from "./PreviewEmailWrapper.vue?vue&type=script&lang=js"
export * from "./PreviewEmailWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports